import axios from 'axios'
import {EntityDto} from '../dto/entityDto'
import {GetProgramsDto} from '../dto/getProgramsDto'
const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_GET_UNIVERSITY_TYPES = `${API_URL}/DataForComboBox/GetUniversityTypes`
export const URL_GET_UNIVERSITIES = `${API_URL}/DataForComboBox/GetUniversities`
export const URL_GET_FACULTIES = `${API_URL}/DataForComboBox/GetFaculties`
export const URL_GET_FACULTIES_BY_ID = `${API_URL}/DataForComboBox/GetFacultiesByUniversityId`
export const URL_GET_DEPARTMENTS = `${API_URL}/DataForComboBox/GetDepartments`
export const URL_GET_DEPARTMENTS_BY_ID = `${API_URL}/DataForComboBox/GetDepartmentsByFacultyId`
export const URL_GET_SUBDEPARTMENTS = `${API_URL}/DataForComboBox/GetSubDepartments`
export const URL_GET_SUBDEPARTMENTS_BY_ID = `${API_URL}/DataForComboBox/GetSubDepartmentsByDepartmentId`
export const URL_GET_PROGRAMS = `${API_URL}/DataForComboBox/GetPrograms`
export const URL_GET_PROGRAMS_BY_IDS = `${API_URL}/DataForComboBox/GetProgramsByDepAndSubDepId`
export const URL_GET_COUNTRIES = `${API_URL}/DataForComboBox/GetCountries`
export const URL_GET_PROVINCE_BY_ID = `${API_URL}/DataForComboBox/GetProvincesByCountryId`
export const URL_GET_DISTRICT_BY_ID = `${API_URL}/DataForComboBox/GetDistrictsByProvinceId`
export const URL_GET_USERS = `${API_URL}/DataForComboBox/GetUsers`
export const URL_GET_ADDRESS_TYPES = `${API_URL}/DataForComboBox/GetAddressTypes`
export const URL_GET_DEGREES = `${API_URL}/DataForComboBox/GetDegrees`
export const URL_GET_PROGRAMTYPE_BY_DEGREE_ID = `${API_URL}/DataForComboBox/GetProgramTypes`
//export const URL_GET_PROGRAMS_BY_DEGREE_ID = `${API_URL}/DataForComboBox/GetPrograms`
export const URL_GET_GRADUATES = `${API_URL}/DataForComboBox/GetGraduates`
export const URL_GET_CARD_STATUSES = `${API_URL}/DataForComboBox/GetCardStatuses`
export const URL_GET_DELIVERY_TYPES = `${API_URL}/DataForComboBox/GetDeliveryTypes`
export const URL_GET_PROGRAMS_WITH_FACULTIES = `${API_URL}/DataForComboBox/GetProgramsWithFaculties`
export const URL_GET_SCORE_TYPES = `${API_URL}/DataForComboBox/GetScoreTypes`
export const URL_GET_GRADUATION_TYPES = `${API_URL}/DataForComboBox/GetGraduationTypes`
export const URL_GET_JOB_TYPES = `${API_URL}/DataForComboBox/GetJobTypes`
export const URL_GET_JOB_LOCATION_TYPES = `${API_URL}/DataForComboBox/GetJobLocationTypes`
export const URL_GET_COMPANIES = `${API_URL}/DataForComboBox/GetCompanies`
export const URL_GET_INSTITUTION_TYPES = `${API_URL}/DataForComboBox/GetInstitutionTypes`
export const URL_GET_CODE_GROUPS = `${API_URL}/DataForComboBox/GetCodeGroups`
export const URL_GET_EMAIL_TEMPLATES = `${API_URL}/DataForComboBox/GetEmailTemplates`
export const URL_GET_NEWS_TYPES = `${API_URL}/DataForComboBox/GetNewsTypes`
export const URL_GET_ATTACHMENT_TYPES = `${API_URL}/DataForComboBox/GetAttachmentTypes`
export const URL_GET_WORK_LOCATION_TYPES = `${API_URL}/DataForComboBox/GetWorkLocationTypes`
export const URL_GET_EMAIL_PARAMETERS = `${API_URL}/DataForComboBox/GetEmailParameters`
export const URL_GET_COMPANY_TYPES = `${API_URL}/DataForComboBox/GetCompanyTypes`
export const URL_GET_CONFIRMATION_STATUSES = `${API_URL}/DataForComboBox/GetConfirmationStatuses`
export const URL_GET_USER_CVS = `${API_URL}/DataForComboBox/GetUserCvs`
export const URL_GET_USER_COVERLETTERS = `${API_URL}/DataForComboBox/GetUserCoverLetter`
export const URL_GET_EMPLOYER_TYPES = `${API_URL}/DataForComboBox/GetEmployerTypes`
export const URL_GET_INDUSTRIES = `${API_URL}/DataForComboBox/GetIndustries`
export const URL_GET_JOB_LEVELS = `${API_URL}/DataForComboBox/GetJobLevels`
export const URL_GET_GENDERS = `${API_URL}/DataForComboBox/GetGenders`

export function onGetGraduatedCvByUser() {
  return axios.get(URL_GET_USER_CVS)
}

export function onGetGraduatedCoverLetterByUser() {
  return axios.get(URL_GET_USER_COVERLETTERS)
}

export function onGetUniversityTypes() {
  return axios.get(URL_GET_UNIVERSITY_TYPES)
}

export function onGetUniversities() {
  return axios.get(URL_GET_UNIVERSITIES)
}

export function onGetEmailParameters() {
  return axios.get(URL_GET_EMAIL_PARAMETERS)
}

export function onGetFaculties() {
  return axios.get(URL_GET_FACULTIES)
}

/*export function onGetFacultiesByUniversityId(param: EntityDto) {
  return axios.get(URL_GET_FACULTIES_BY_ID, {params: param})
}*/

export function onGetDepartments() {
  return axios.get(URL_GET_DEPARTMENTS)
}

export function onGetDepartmentsByFacultyId(param: EntityDto) {
  return axios.get(URL_GET_DEPARTMENTS_BY_ID, {params: param})
}

export function onGetSubDepartments() {
  return axios.get(URL_GET_SUBDEPARTMENTS)
}

export function onGetSubDepartmentsByDepartmentId(param: EntityDto) {
  return axios.get(URL_GET_SUBDEPARTMENTS_BY_ID, {params: param})
}

export function onGetDegrees() {
  return axios.get(URL_GET_DEGREES)
}

export function onGetProgramTypesByDegreeId(param: EntityDto) {
  return axios.get(URL_GET_PROGRAMS_BY_IDS, {params: param})
}

export function onGetPrograms() {
  return axios.get(URL_GET_PROGRAMS)
}

export function onGetProgramsByDepAndSubDepId(param: GetProgramsDto) {
  return axios.get(URL_GET_PROGRAMS_BY_IDS, {params: param})
}

export function onGetCountries() {
  return axios.get(URL_GET_COUNTRIES)
}

export function onGetProvincesByCountryId(param: EntityDto) {
  return axios.get(URL_GET_PROVINCE_BY_ID, {params: param})
}

export function onGetDistrictsByProvinceId(param: EntityDto) {
  return axios.get(URL_GET_DISTRICT_BY_ID, {params: param})
}

export function onGetUsers() {
  return axios.get(URL_GET_USERS)
}

export function onGetAddressTypes() {
  return axios.get(URL_GET_ADDRESS_TYPES)
}

export function onGetGraduates() {
  return axios.get(URL_GET_GRADUATES)
}

export function onGetCardStatuses() {
  return axios.get(URL_GET_CARD_STATUSES)
}

export function onGetDeliveryTypes() {
  return axios.get(URL_GET_DELIVERY_TYPES)
}

export function onGetProgramsWithFaculties() {
  return axios.get(URL_GET_PROGRAMS_WITH_FACULTIES)
}

export function onGetScoreTypes() {
  return axios.get(URL_GET_SCORE_TYPES)
}

export function onGetGraduationTypes() {
  return axios.get(URL_GET_GRADUATION_TYPES)
}

export function onGetJobTypes() {
  return axios.get(URL_GET_JOB_TYPES)
}

export function onGetJobLocationTypes() {
  return axios.get(URL_GET_JOB_LOCATION_TYPES)
}

export function onGetCompanies() {
  return axios.get(URL_GET_COMPANIES)
}

export function onGetInstitutionTypes() {
  return axios.get(URL_GET_INSTITUTION_TYPES)
}

export function onGetCodeGroups() {
  return axios.get(URL_GET_CODE_GROUPS)
}

export function onGetEmailTemplates() {
  return axios.get(URL_GET_EMAIL_TEMPLATES)
}
export function onGetNewsTypes() {
  return axios.get(URL_GET_NEWS_TYPES)
}

export function onGetAttachmentTypes() {
  return axios.get(URL_GET_ATTACHMENT_TYPES)
}

export function onGetWorkLocationTypes() {
  return axios.get(URL_GET_WORK_LOCATION_TYPES)
}

export function onGetCompanyTypes() {
  return axios.get(URL_GET_COMPANY_TYPES)
}

export function onGetConfirmationStatuses() {
  return axios.get(URL_GET_CONFIRMATION_STATUSES)
}

export function onGetEmployerTypes() {
  return axios.get(URL_GET_EMPLOYER_TYPES)
}
export function onGetIndustries() {
  return axios.get(URL_GET_INDUSTRIES)
}
export function onGetJobLevels() {
  return axios.get(URL_GET_JOB_LEVELS)
}
export function onGetGenders() {
  return axios.get(URL_GET_GENDERS)
}